/**
 * @file SideNav.tsx
 *
 * Desktop side navigation for the Online Shop admin. Renders the Gravity
 * compact sidebar with the shop sections (Products, Categories, Orders,
 * Coupons, Shipping); the active item is derived from the current route via
 * react-router's {@link NavLink}.
 */

import { FormattedMessage, useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { adminMessages } from '../i18n/messages';
import { SHOP_NAV_ITEMS } from '../nav-items';
import styles from './AdminLayout.module.css';

/**
 * The Gravity compact sidebar shown on desktop viewports.
 *
 * @returns The shop section navigation.
 */
export function SideNav() {
  const intl = useIntl();
  return (
    <div
      className={`gv-sidebar gv-sidebar-compact gv-surface-bright ${styles.sideMenu}`}
    >
      <div className="gv-side-menu">
        <div className="gv-side-label">
          <FormattedMessage {...adminMessages.shopTitle} />
        </div>
        <nav
          className="gv-side-nav"
          data-testid="side-nav"
          aria-label={intl.formatMessage(adminMessages.shopTitle)}
        >
          <ul>
            {SHOP_NAV_ITEMS.map((item) => (
              <li key={item.id}>
                <NavLink
                  to={item.path}
                  data-testid={`side-nav-${item.id}`}
                  className={({ isActive }) =>
                    `gv-nav-item ${isActive ? 'gv-active' : ''}`
                  }
                >
                  <span>
                    <FormattedMessage {...item.label} />
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}
